import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { TestimonialsSection1, TestimonialsSection2 } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { Bonuses } from './components/Bonuses';
import { PurchaseSection } from './components/PurchaseSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { StickyMobileCTA } from './components/StickyMobileCTA';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1723310688650304');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-brand-dark font-sans pb-16 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <SocialProofBar data-id="element-2" />
      <TestimonialsSection1 data-id="element-3" />
      <PainPoints data-id="element-4" />
      <ProductShowcase data-id="element-5" />
      <Bonuses data-id="element-6" />
      <PurchaseSection id="compra" data-id="element-7" />
      <TestimonialsSection2 data-id="element-8" />
      <Guarantee data-id="element-9" />
      <FAQ data-id="element-10" />

      {/* Final CTA Section */}
      <section className="pt-6 md:pt-8 px-4 bg-brand-dark text-center" data-id="element-11">
        <div className="max-w-3xl mx-auto" data-id="element-12">
          <h2 className="text-lg md:text-2xl font-black text-white mb-1 tracking-tight leading-tight" data-id="element-13">
            El próximo fin de semana podés seguir buscando ejercicios en
            internet...
          </h2>
          <p className="text-base md:text-xl font-black text-brand-accent neon-glow mb-2" data-id="element-14">
            O podés tener todo resuelto desde hoy.
          </p>
          <p className="text-xs text-gray-400 font-medium max-w-xl mx-auto mb-4 leading-relaxed" data-id="element-15">
            Da igual si estás en Argentina, en México, en Colombia, en Chile, en
            Perú, en Guatemala, en Venezuela o en cualquier rincón de
            Latinoamérica donde se hable español. El problema es el mismo.{' '}
            <span className="text-white font-bold" data-id="element-16">La solución también.</span>
          </p>
        </div>
      </section>
      <PurchaseSection data-id="element-17" />

      <Footer data-id="element-18" />
      <SocialProofPopup data-id="element-19" />
      <StickyMobileCTA data-id="element-20" />

      <noscript data-id="element-21">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1723310688650304&ev=PageView&noscript=1" alt="" data-id="element-22" />
      </noscript>
    </div>;
}